<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 11.4874L11.182 14.6694L16.8388 9.01255" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <rect x="0.75" y="0.75" width="22.5" height="22.5" rx="11.25" stroke="currentColor" stroke-width="1.5"/>
    </svg>
</template>

<script>
export default {
    name: 'SVGConfirm',
};
</script>

<style scoped>

</style>